import { Col, Row, Space } from "antd";
import React from "react";
import ActionButtons from "./ActionButtons";
import { LeaseActionDropdown } from "./LeaseActions";
import { useLeaseActionDropdown } from "./LeaseActions/useLeaseActionDropdown";

interface IProps {
  handleEditPress?: (arg0: string, arg1: Boolean) => void;
  booking?: any;
  label: string;
  renewal?: boolean;
  actions?: boolean;
  parentState?: (obj: object) => void;
  setRenewalFormConfirm?: any;
  moveOutScreen?: any;
  setSendSettlementReport?: any;
  showRenewalBtn?: any;
  setShowCheckList?: (showCheckList: boolean) => void;
}

const index = (props: IProps) => {
  const { booking, actions, moveOutScreen, renewal, label, setSendSettlementReport, handleEditPress, parentState } =
    props;

  const { isLeaseActionDropdownVisible, items } = useLeaseActionDropdown({ renewal });

  const canShowActionButtons =
    booking?.leaseStatus !== "lease_renewed" &&
    ((actions && booking?.leaseStatus !== "lease_terminated") || moveOutScreen);

  console.log(renewal, "renewal");
  return (
    <Row gutter={24} className="bf-action-header" justify="space-between" align="middle">
      <Col flex="auto" className="bf-action-header_left">
        <p className="bf-action-header_left-title">Pages /</p>
        <p className="bf-action-header_left-name">
          {booking?.leaseType && (renewal == false ? "Booking Form" : label || "Renewal Form")}
        </p>
      </Col>

      <Col flex="none" className="bf-action-header_right">
        <Space size={8}>
          {canShowActionButtons && (
            <ActionButtons
              // setShowCheckList={props?.setShowCheckList}
              setSendSettlementReport={setSendSettlementReport}
              handleEditPressEvent={(key: string) => handleEditPress?.(key, true)}
              setLoading={(value) => parentState({ value })}
              renewal={renewal}
            />
          )}

          {/* lease Action deropdown hide in case of renewal right now beacuse 
           this feature development stop later on we can open it renewal */}
          {isLeaseActionDropdownVisible && <LeaseActionDropdown items={items} />}
        </Space>
      </Col>
    </Row>
  );
};

export default index;
